import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myCafateriaNewStatementItemState = atom({
  key: "myCafateriaNewStatementItemState",
  default: {
    index: 0,
    contractCode: "",
    currentItemStartDate: "", // YYYYMMDD format
    menuItemCode: "",
    startDate: "", // in MM fromat
    endDate: "", // in MM format
    type: "",
    amount: "",
    bruttoAmount: "",
    benefitType: "",
    szepCardApplicationAmount: "",
  },
  effects_UNSTABLE: [ocPersistAtom],
});

export default myCafateriaNewStatementItemState;
